<template>
  <div v-if="!loading" class="dash-content">
    <a onclick="history.back()" class="return">
      &lt; Back to Bookings
    </a>
    <div v-if="!dashboardCodeValid">
      Dashboard not found. Please check the URL.
    </div>
    <div v-else class="dash-container">
      <h2 class="dash-title">{{ title }}</h2>

      <div class="dash-header-table">
        <div class="dash-header-row">
          <div class="dash-header-title"><div>Number of teams</div></div>
          <div class="dash-header-item">
            <div>{{ numberOfTeams }}</div>
          </div>
        </div>
        <div class="dash-header-row">
          <div class="dash-header-title"><div>Number of players</div></div>
          <div class="dash-header-item">
            <div>{{ numberOfPlayers }}</div>
          </div>
        </div>
        <div class="dash-header-row">
          <div class="dash-header-title"><div>Leaderboard</div></div>
          <div class="dash-header-item">
            <div>
              <router-link
                :to="{
                  name: 'game-scoreboard',
                  params: { code: code, team_id: 0 }
                }"
                class=" dash-header-button"
              >
                Go to Leaderboard
              </router-link>
            </div>
          </div>
        </div>
        <div class="dash-header-row">
          <div class="dash-header-title"><div>Last Login</div></div>
          <div class="dash-header-item">
            <div>
              {{ gameDate }}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="dash-teams">
        <div class="dash-table-head">
          <div class="dash-item dash-name"><div>Team name</div></div>
          <div class="dash-item dash-members"><div>Members</div></div>
          <div class="dash-item dash-points"><div>Points</div></div>
          <div class="dash-item dash-progress"><div>Progress</div></div>
          <div class="dash-item dash-last-active"><div>Last Active</div></div>
          <div class="dash-item dash-duration"><div>Play Duration</div></div>
          <div class="dash-item dash-join"><div>View Live Game</div></div>
        </div>

        <div
          v-for="(team, index) in orderedTeams"
          :key="index"
          class="dash-team-row"
        >
          <div class="dash-item dash-name">
            <div class="dash-team-name">{{ team.teamName }}</div>
          </div>
          <div class="dash-item dash-members">
            <div>{{ team.teamMembers.join(', ') }}</div>
          </div>
          <div class="dash-item dash-points">
            <div>{{ team.points }}</div>
          </div>
          <div class="dash-item dash-progress">
            <div class="dash-percent">{{ team.progress }}%</div>
          </div>
          <div class="dash-item dash-last-active">
            <div>{{ moment(team.updated.seconds * 1000).fromNow() }}</div>
          </div>
          <div class="dash-item dash-duration">
            <div>
              {{
                team.updated
                  ? momentDuration(
                      moment(team.updated.seconds * 1000).diff(
                        moment(team.created.seconds * 1000)
                      )
                    ).humanize()
                  : ''
              }}
            </div>
          </div>
          <div class="dash-item dash-join">
            <a
              @click="doJoinGame(team.id)"
              class="dash-button dash-full dash-w-button"
              >View Live</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import md5 from 'md5'

export default {
  props: {
    code: { type: String, required: true },
    dashboard_code: { type: String, required: true }
  },
  created() {
    if (this.game?.game === undefined || this.game?.game?.id != this.code) {
      this.fetchGame({ code: this.code })
    }
    if (
      this.game?.teams === undefined ||
      this.game?.teams[0]?.gameCode != this.code
    ) {
      this.fetchTeams({ code: this.code })
    }
  },
  mounted() {
    document.querySelector('body').classList.add('display-scrollbar')
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('display-scrollbar')
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    dashboardCodeValid() {
      return this.dashboard_code === md5(this.code)
    },
    orderedTeams() {
      return this.teams.slice().sort((a, b) =>
        a.teamName
          .trim()
          .toLowerCase()
          .localeCompare(b.teamName.trim().toLowerCase(), 'en', {
            numeric: true
          })
      )
    },
    gameDate() {
      let lastUpdatedSeconds = this.teams[0]?.updated.seconds

      if (!lastUpdatedSeconds) {
        return 'Game not played yet.'
      }

      return moment(lastUpdatedSeconds * 1000).format('DD/MM/YYYY')
    },
    numberOfTeams() {
      return this.teams.length
    },
    numberOfPlayers() {
      return this.teams.reduce(
        (previousValue, currentValue) =>
          previousValue + currentValue.teamMembers.length,
        0
      )
    },
    loading() {
      return this.game.game === undefined
    },
    title() {
      return this.game.game?.eventName
    },
    teams() {
      return this.game.teams
    }
  },
  methods: {
    ...mapActions('game', ['fetchTeams', 'fetchGame']),
    moment: function(date) {
      return moment(date)
    },
    momentDuration: function(ms) {
      return moment.duration(ms)
    },
    doJoinGame: function(teamId) {
      let routeData = this.$router.resolve({
        name: 'challenge-play',
        params: { code: this.code, team_id: teamId, challengeIndex: -1 }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap');
@import url('https://fonts.googleapis.com/css?family=Poppins|Roboto');

.return {
  font-family: Poppins, sans-serif;
  background-color: transparent;
  display: block;
  margin-right: 15px;
  margin-bottom: 15px;
  color: rgb(253, 118, 36);
  text-decoration: none;
  text-decoration-line: none;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
  cursor: pointer;
}

a.return:active,
a.return:hover {
  outline: 0;
  outline-color: initial;
  outline-style: initial;
  outline-width: 0px;
  color: rgb(253, 118, 36) !important;
}

.return:hover {
  color: rgb(253, 118, 36) !important;
  text-decoration: underline !important;
  text-decoration-line: underline;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
}

.dash-content {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: 'Space Grotesk', sans-serif;
}
.dash-container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 20px;
  padding-left: 20px;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.dash-title {
  margin-top: 20px;
  margin-bottom: 10px;
  color: #fd7624;
  font-size: 48px;
  line-height: 50px;
  font-weight: 700;
}
.dash-table-head {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 4px;
  padding: 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  border-radius: 4px;
  background-color: #ececec;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.dash-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding: 10px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-right: 1px solid #d1d1d1;
  text-align: center;
}
.dash-item.dash-name {
  max-width: 15%;
}
.dash-item.dash-points {
  max-width: 10%;
}
.dash-item.dash-members {
  max-width: 20%;
}
.dash-item.dash-progress {
  width: 10%;
}
.dash-item.dash-last-active {
  width: 15%;
}
.dash-item.dash-duration {
  width: 15%;
}

.dash-item.dash-join {
  max-width: 15%;
  border-right-style: none;
}
.dash-team-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 4px;
  padding: 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  border-radius: 4px;
  background-color: #fff;
  color: #474747;
  font-size: 16px;
}

.dash-team-name {
  color: #2e186a;
  font-weight: 700;
}

.dash-percent {
  font-weight: 700;
}

.dash-teams {
  background-color: #f3f3f3;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 1px;
}

.dash-button:hover {
  background-color: #2e186a !important;
}

a.dash-button:active,
a.dash-button:hover {
  outline: 0 !important;
}

.dash-button.dash-full {
  width: 100%;
}

.dash-button {
  padding: 10px 20px !important;
  border-radius: 4px !important;
  background-color: #b239f1 !important;
  -webkit-transition: 0.2s !important;
  transition: 0.2s !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
}

.dash-w-button {
  display: inline-block;
  padding: 9px 15px;
  background-color: #3898ec;
  color: #fff;
  border: 0;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0;
}

.dash-header-button:hover {
  background-color: #2e186a !important;
}

a.dash-header-button:active,
a.dash-header-button:hover {
  outline: 0 !important;
}

.dash-header-button.dash-full {
  width: 100%;
}

.dash-header-button {
  padding: 5px;
  border-radius: 4px !important;
  color: #fff;
  background-color: #4744f8 !important;
  -webkit-transition: 0.2s !important;
  transition: 0.2s !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
}
.dash-header-table {
  background-color: #f3f3f3;
  padding-left: 2px;
  padding-right: 2px;
  margin-right: 60%;
  padding-top: 2px;
  padding-bottom: 1px;
}

.dash-header-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 4px;
  padding: 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  border-radius: 4px;
  background-color: #fff;
  color: #474747;
  font-size: 16px;
}

.dash-header-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding: 2px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-right: 1px solid #d1d1d1;
  text-align: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.dash-header-title {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding: 2px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-right: 1px solid #d1d1d1;
  text-align: left;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: left;
  font-weight: bold;
}
</style>
